import { toast } from 'sonner';

export function notify(type: 'error' | 'success', message: string): void {
  if (type === 'error') {
    toast.error(message, {
      className: 'toasterror',
    });
  }
  if (type === 'success') {
    toast.success(message, {
      className: 'toastsuccess',
    });
  }
}
